export const templatesEn = {
    title: 'Print Templates',
    create: 'Create print template',
    columns: {
        name: 'Name',
        type: 'Type',
        version: 'Version',
        fileName: 'File name',
        lastEditor: 'Last editor',
        checksum: 'Checksum'
    },
    types: {
        rfid_chip: 'RFID Chip',
        parcel_label: 'Parcel label',
        end_roll_label: 'End roll label'
    },
    dialog: {
        createTitle: 'Create print template',
        editTitle: 'Edit print template',
        deleteTitle: 'Delete print template',
        deleteContent: 'Are you sure you want to delete the print template "{name}"?'
    },
    form: {
        name: 'Name',
        type: 'Type',
        filePlaceholder: 'Drag and drop a file here or click to browse',
        fileOptional: 'Drag and drop a new file to replace the current one (optional)',
        browseFile: 'Browse file'
    },
    actions: {
        download: 'Download',
        edit: 'Edit',
        delete: 'Delete'
    },
    success: {
        created: 'Print template created successfully',
        updated: 'Print template updated successfully',
        deleted: 'Print template deleted successfully'
    }
}
